/** ID-token company id. Never a request body, a demo constant, or an unfiltered fallback. */

export const MISSING_COMPANY_CLAIM_ERROR =
    'This session has no company id. Sign out and sign in again.';

export function companyIdFromClaims(claims: { companyId?: unknown } | null | undefined): string | null {
    if (!claims || typeof claims.companyId !== 'string') return null;
    const companyId = claims.companyId.trim();
    return companyId ? companyId : null;
}
